// @ts-nocheck
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui";
import { cn } from "@/lib/utils";
import { NotifIcon } from "./NotifIcon";
import { fmtDate } from "./sellerDetail.utils";

export const NotificationsTab = ({ d }) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-base">Notifications</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3">
        {d.notifications.map((n) => (
          <div
            key={n.id}
            data-testid={`notif-${n.id}`}
            className={cn(
              "flex items-start gap-3 p-3 rounded-lg border",
              n.read
                ? "bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700"
                : "bg-indigo-50/50 dark:bg-indigo-950/20 border-indigo-200 dark:border-indigo-800",
            )}
          >
            <NotifIcon type={n.type} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-slate-900 dark:text-slate-100">
                {n.title}
              </p>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                {n.message}
              </p>
            </div>
            <span className="text-xs text-slate-400 dark:text-slate-500 shrink-0">
              {fmtDate(n.date)}
            </span>
            {!n.read && (
              <span className="w-2 h-2 rounded-full bg-indigo-500 shrink-0 mt-1" />
            )}
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);
